import React from 'react';
import { connect } from 'react-redux';
import { showModalMessage } from '../store/modalsSlice';
import EditingDataHistoryDialog from '../components/editingDataHistoryDialog';
import ClientHistoryTable from '../components/clientHisotryTable';
import * as objectHistory from '../store/objectHistorySlice';
import { objectHistoryNames, objectHistorySelectors } from '../store/objectHistorySlice';
import { clientsSelectors } from '../store/clientsSlice';
import ClientHistoryTableHeader from '../components/clientHistoryTableHeader';

class clientHistoryDialog extends EditingDataHistoryDialog {
  get dataId() {
    return this.props.id;
  }

  get Title() {
    return 'Client history';
  }

  renderTable(tableProps) {
    return <ClientHistoryTable {...tableProps}/>
  }

  renderBeforeContent() {
    const objectData = this.props.selectedClient(this.props.id);
    const editedFields = this.props.getEditedFields();
    return <ClientHistoryTableHeader editedFields={editedFields} objectData={objectData}/>;
  }

  getLoaderMessage() {
    return 'Client history loading...';
  }
}

const mapStateToProps = (state) => ({
  objectState: objectHistorySelectors.clients(state),
  getEditedFields: () => objectHistorySelectors.clientsEditedFields(state),
  selectedClient: (id) => clientsSelectors.selectById(state, id),
});

const actionCreators = {
  fetchHistory: (clientId) => objectHistory.fetchHistory(clientId, objectHistoryNames.clients),
  showModalMessage: (title, text) => showModalMessage({ title, text }),
};

export default connect(mapStateToProps, actionCreators)(clientHistoryDialog);



// WEBPACK FOOTER //
// ./src/containers/clientHistoryDialog.js